(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loop-widget-custom-trial-and-subscribe"] && !Shopify.designMode) return;
  try {
    function getVariantFromURL() {
const urlParams = new URLSearchParams(window.location.search);
const variant = urlParams.get('variant');
console.log("Extracted Variant ID:", variant);
return variant;
}

function getProductIdFromLoopProps() {
if (typeof loopProps === 'undefined') {
console.log("loopProps is not defined.");
return null;
}

const productIds = Object.keys(loopProps);
if (productIds.length === 0) {
console.log("No product ID found in loopProps.");
return null;
}

const pid = productIds[0];
console.log("Extracted Product ID from loopProps:", pid);
return pid;
}

function handleVariantChange() {
let variantId = getVariantFromURL();
if (!variantId) {
console.log("No variant ID found in URL.");
return;
}

let pid = getProductIdFromLoopProps();
if (!pid) {
console.log("Failed to get product ID.");
return;
}

const productData = getLoopProductData(pid);
console.log("Product Data:", productData);

loopVariantChanged({ loopProduct: productData, variantId });
console.log("Variant change triggered with:", { loopProduct: productData, variantId });
}

// Run on page load
window.onload = handleVariantChange;

//  Listen for SPA URL changes (history API manipulation)
(function () {
let lastUrl = location.href;

new MutationObserver(() => {
if (location.href !== lastUrl) {
lastUrl = location.href;
console.log("URL changed, re-running variant check.");
handleVariantChange();
}
}).observe(document, { subtree: true, childList: true });

window.addEventListener('popstate', handleVariantChange);
})();
  } catch(e) { console.error(e); }
})();

})();
